module.exports = __webpack_public_path__ + "static/product_scout-a730ca8dafd0459fe9d8864158726d82.png";